import React from 'react';
import { FadeIn } from './FadeIn';
import { TrustBadges } from './TrustBadges';
import { ChevronRightIcon, CheckCircle2Icon } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-16 sm:py-24 px-4 bg-hyrox-surface relative" data-id="element-135">
      {/* Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-hyrox-orange/5 rounded-full blur-[100px] pointer-events-none" data-id="element-136" />

      <div className="max-w-xl mx-auto relative z-10" data-id="element-137">
        <FadeIn delay={0.1} data-id="element-138">
          <div className="bg-gradient-to-b from-hyrox-surfaceHover to-hyrox-dark border-2 border-hyrox-orange p-8 sm:p-10 rounded-3xl flex flex-col relative shadow-[0_0_60px_rgba(255,107,26,0.15)]" data-id="element-139">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-hyrox-orange text-white font-bold px-5 py-1.5 rounded-full text-sm uppercase tracking-wider shadow-[0_0_20px_rgba(255,107,26,0.4)]" data-id="element-140">
              Precio de lanzamiento
            </div>

            <div className="text-center mb-6 mt-2" data-id="element-141">
              <span className="text-4xl mb-3 block" data-id="element-142">🏋️</span>
              <h3 className="text-2xl sm:text-3xl font-display font-bold text-white mb-2" data-id="element-143">
                MEGA PACK HYROX PARA COACHES
              </h3>
              <p className="text-gray-400" data-id="element-144">
                El sistema completo para coaches que quieren dejar de improvisar
                y empezar a cobrar lo que valen.
              </p>
            </div>

            <ul className="space-y-3 mb-8 max-w-sm mx-auto w-full" data-id="element-145">
              {['6 Tomos del Sistema (120+ páginas)', 'Bono 1 — Protocolo Sub-10', 'Bono 2 — HYROX Engine', 'Bono 3 — Las 8 Estaciones Sin Puntos Débiles', 'Bono 4 — Transiciones de Élite', 'Bono 5 — Race Strategy HYROX', 'Acceso inmediato y descarga permanente'].map((item, i) => <li key={i} className="flex items-center gap-3 text-white font-medium" data-id="element-146">
                  <CheckCircle2Icon className="w-5 h-5 text-hyrox-orange shrink-0" data-id="element-147" />
                  <span data-id="element-148">{item}</span>
                </li>)}
            </ul>

            <div className="text-center mb-8" data-id="element-149">
              <p className="text-gray-400 text-sm mb-3" data-id="element-150">
                Precio de lanzamiento:
              </p>
              <div className="text-5xl sm:text-6xl font-display font-black text-hyrox-orange drop-shadow-[0_0_20px_rgba(255,107,26,0.4)]" data-id="element-151">
                $16.990
              </div>
              <p className="text-gray-500 text-sm mt-2" data-id="element-152">
                Acceso inmediato — Descarga permanente
              </p>
            </div>

            <a href="https://codigo-hyrox.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" className="w-full bg-hyrox-orange hover:bg-hyrox-orangeHover text-white font-display rounded-xl px-6 py-4 flex flex-col items-center justify-center transition-all transform hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_30px_rgba(255,107,26,0.25)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-hyrox-orange" data-id="element-153">
              <span className="flex items-center gap-2 font-black text-xl leading-none" data-id="element-154">
                QUIERO EL PACK AHORA
                <ChevronRightIcon className="w-6 h-6" strokeWidth={3} data-id="element-155" />
              </span>
              <span className="font-bold text-sm text-white/80 mt-1" data-id="element-156">
                $16.990 — Acceso inmediato
              </span>
            </a>

            <div className="mt-8" data-id="element-157">
              <TrustBadges data-id="element-158" />
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}